import { ListInput } from "framework7-react";
import { maxSpentAtInput } from "../utils/spent-at-form";

const SpentAtInput = ({ value, onChange }) => (
  <ListInput
    className="spent-at-input"
    name="spent-at"
    label="Zeitpunkt"
    type="datetime-local"
    outline
    value={value}
    max={maxSpentAtInput()}
    onChange={(event) => onChange(event.target.value)}
  />
);

// F7's <List> only renders children named f7-list-input* inside its <ul>.
SpentAtInput.displayName = "f7-list-input-spent-at";

export default SpentAtInput;
